import src from "IMAGE";
export default { src, width: 880, height: 800, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/webp;base64,UklGRnEAAABXRUJQVlA4TGUAAAAvB4ABAM1VICICHgiADQIAAIB7PE0XgQvJQQAQAMAREAAgAAAAAAAAAAAAAAABIAAkQo0EEKWk+GsBAAAiIuu05/E8eioJNdD3+pxddr0fccptCqRiLsuti2DA5ShMVQLt2LXNDwA="};
